export default __webpack_public_path__ + "static/media/onboardingLogoMb.9484d949.svg";